import { Award, Check } from 'lucide-react';
import { WHY_MONDAINE, CREDENTIALS } from '../../data/mock';

export default function WhyMondaine() {
  return (
    <section className="py-24 lg:py-36 bg-ivory-warm">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14 reveal">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <Award size={16} className="text-champagne-deep" />
              <p className="text-[11px] tracking-[0.3em] uppercase text-champagne-deep">Why Mondaine Style</p>
            </div>
            <h2 className="font-serif text-4xl lg:text-6xl leading-[1.05] text-charcoal">
              A style practice built on <em className="italic-accent">experience, education &amp; engagement.</em>
            </h2>
          </div>
          <p className="max-w-md text-charcoal/70 leading-relaxed">
            Mondaine Style is led by <strong className="text-charcoal">Anitya Vatsal</strong>, a NIFT Bangalore alumnus with 14+ years in menswear, personal styling, retail and image strategy — working across academia, industry and professional communities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-px bg-charcoal/10 reveal">
          {WHY_MONDAINE.map((w) => (
            <div key={w.n} className="group bg-ivory-warm p-8 hover:bg-ivory transition-colors duration-500">
              <span className="font-display text-xs tracking-[0.3em] text-champagne-deep">{w.n}</span>
              <h3 className="font-serif text-xl mt-4 leading-tight text-charcoal">{w.t}</h3>
              <p className="mt-4 text-sm text-charcoal/70 leading-relaxed">{w.b}</p>
              <div className="mt-6 h-px w-8 bg-champagne-deep group-hover:w-16 transition-all duration-500" />
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 reveal">
          <div className="lg:col-span-4">
            <p className="text-[10px] tracking-[0.3em] uppercase text-champagne-deep mb-4">Credentials &amp; Engagements</p>
            <h3 className="font-serif text-2xl lg:text-3xl text-charcoal leading-[1.15]">
              A practice that <em className="italic-accent">operates across academia, industry &amp; professional communities.</em>
            </h3>
          </div>
          <div className="lg:col-span-8">
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
              {CREDENTIALS.map((c, i) => (
                <li key={i} className="flex items-start gap-3 py-3 border-b border-charcoal/10 last:border-b-0 md:[&:nth-last-child(2)]:border-b-0">
                  <Check size={14} className="text-champagne-deep mt-1.5 shrink-0" />
                  <span className="text-sm md:text-base text-charcoal/85 leading-relaxed">{c}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
